import { useContext } from 'react';
import css from './Dev_indicator.module.css';
import { CatalogContext } from 'Catalog/Catalog.context';

export default function Dev_indicator() {
  const { pageMap, pageNum } = useContext(CatalogContext);
  return <div className={`${css.container}`}>PageFile: {pageMap[pageNum - 1]}.jsx</div>;
}
